import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/partners/usePartnerQueryKeys.ts
var t = e("partners", { application: () => ["application"] });
//#endregion
export { t as partnerQueryKeys };
